import React, { useState } from 'react';
import PageWrapper from '../components/layout/PageWrapper';
import Container from '../components/layout/Container';
import ExploreGrid from '../components/explore/ExploreGrid';
import * as FiIcons from 'react-icons/fi';

const { FiCode, FiPenTool } = FiIcons;

export default function ExplorePage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  const pages = [
    { username: 'alexdoe', descriptor: 'Building tools for makers', lastActive: '2 hours ago', category: 'code', icon: FiCode, recentWork: 'Refactored authentication system' },
    { username: 'sarah_builds', descriptor: 'Product designer & prototyper', lastActive: '5 hours ago', category: 'design', icon: FiPenTool, recentWork: 'Designed onboarding flow' }
  ];

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'code', label: 'Code' },
    { id: 'design', label: 'Design' }
  ];

  return (
    <PageWrapper>
      <Container className="py-12">
        <div className="mb-16">
          <h1 className="text-6xl font-black text-white mb-6 uppercase italic tracking-tighter">Discovery.</h1>
          <p className="text-xl text-slate-500 font-medium">Browse the builders shaping the future.</p>
        </div>

        <div className="flex space-x-3 mb-12 overflow-x-auto pb-4 no-scrollbar">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setSelectedCategory(cat.id)}
              className={`px-8 py-3 rounded-2xl text-xs font-black uppercase tracking-widest transition-all ${
                selectedCategory === cat.id 
                  ? 'bg-white text-slate-950 shadow-xl' 
                  : 'bg-white/5 text-slate-500 hover:text-white border border-white/5'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        <ExploreGrid pages={pages} />
      </Container>
    </PageWrapper>
  );
}